import { globalFontFace } from "@vanilla-extract/css";
import fontRegular from "../assets/fonts/Geist-Regular.ttf";
import fontMono from "../assets/fonts/GeistMono-Regular.ttf";

export const fontRegularFamily = "Geist Regular";

globalFontFace(fontRegularFamily, {
  src: `url("${fontRegular}") format("truetype")`,
  fontWeight: 400,
  fontStyle: "normal"
});

export const fontMonoFamily = "Geist Mono";

globalFontFace(fontMonoFamily, {
  src: `url("${fontMono}") format("truetype")`,
  fontWeight: 400,
  fontStyle: "normal"
});
